module.exports = __webpack_public_path__ + "static/media/mainardo-denardis.5bd95dec.jpeg";